@if (step === 'loading') {
  <mat-dialog-content>
    <div class="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    @if (errorMessage) {
      <p class="error-banner">{{ errorMessage }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
  </mat-dialog-actions>
} @else if (step === 'scan') {
  <form (ngSubmit)="confirm()">
    <mat-dialog-content>
      <p>
        <strong>1.</strong> Öffne eine Authenticator-App (z. B. Google Authenticator, Microsoft Authenticator oder
        Aegis) und scanne diesen QR-Code:
      </p>
      <img class="qr-code" [src]="setup!.qrDataUrl" alt="QR-Code für die Authenticator-App" width="240" height="240" />
      <p class="secret-hint">
        Kein Scan möglich? Schlüssel von Hand eingeben:
        <code class="secret">{{ setup!.secret }}</code>
      </p>

      <p><strong>2.</strong> Gib den 6-stelligen Code ein, den die App jetzt anzeigt:</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Code</mat-label>
        <input matInput [formControl]="code" inputmode="numeric" autocomplete="one-time-code" maxlength="7" />
      </mat-form-field>

      @if (errorMessage) {
        <p class="error-banner">{{ errorMessage }}</p>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()" [disabled]="submitting">Abbrechen</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
        @if (submitting) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Bestätigen
        }
      </button>
    </mat-dialog-actions>
  </form>
} @else {
  <mat-dialog-content>
    <p>
      Die Zwei-Faktor-Authentisierung ist eingerichtet. Speichere jetzt diese <strong>Recovery-Codes</strong> an einem
      sicheren Ort (z. B. Passwortmanager). Jeder Code funktioniert genau einmal, falls du dein Handy verlierst.
      Sie werden nur dieses eine Mal angezeigt.
    </p>
    <ul class="recovery-codes">
      @for (recoveryCode of recoveryCodes; track recoveryCode) {
        <li>{{ recoveryCode }}</li>
      }
    </ul>
    <button mat-stroked-button type="button" (click)="copyCodes()">Codes kopieren</button>
    <mat-checkbox class="saved-checkbox" [(ngModel)]="codesSaved">Ich habe die Codes gespeichert.</mat-checkbox>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="button" (click)="finish()" [disabled]="!codesSaved">Fertig</button>
  </mat-dialog-actions>
}
